import React, { useState, useEffect } from "react" ;
import PostsAppSidebar from "./Sidebar/PostsAppSidebar";
import PostsAppBody from "./Body/PostsAppBody";

const WieldyApplicationModulePosts = (props) =>
{
    const [ height, setHeight ] = useState ( props.height ) ;
    const [ width, setWidth] = useState ( props.width ) ;
    const pageStyle = { height: '' + (+height-1) + 'px' } ;

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    return (
        <div className="row">
            <div className="col-xl-12">

                <div className="dt-module" style={pageStyle}>

                    <PostsAppSidebar title={'My Posts'} iconName={'icon-camera'} height={height} width={width}/>
                    <PostsAppBody height={height}/>

                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModulePosts;